import { useAuth } from '@/plugins/auth/src'
import { randomUUID } from '@/views/pages/buyer-outlook/utils/randomUUID'
import { useHttp } from '@/plugins/http/src/index'
import _ from 'lodash'

export enum UserAnalysisActionsEnum {
  // click level
  BUTTON_CLICK = 'button_click',
  TABLE_CELL_CLICK = 'table_cell_click',

  // form level
  FORM_SUBMIT = 'form_submit',

  // page level
  PAGE_VISIT = 'page_visit',

  // chat level
  CHAT_MESSAGE_SEND = 'chat_message_send',

  // file uploader level
  FILE_UPLOADER_OPEN = 'file_uploader_open',
  FILE_UPLOADER_CLOSE = 'file_uploader_close',
  FILE_UPLOADER_CHOOSE_FILE = 'file_uploader_choose_file',
  FILE_UPLOADER_UPLOAD_FILE = 'file_uploader_upload_file',
  FILE_UPLOADER_CANCEL_UPLOAD = 'file_uploader_cancel_upload',
  FILE_UPLOADER_DELETE_FILE = 'file_uploader_delete_file'
}

export type UserAnalysisTrackActionType = {
  email: string
  anonymous: string
  company_id?: number
  company_name: string
  session_id: number
  action_type: UserAnalysisActionsEnum
  action_details: string
  page_url: string
}

export interface UerAnalysisStartSessionParams {
  page_url: string
}

export const userAnalysisStartSession = async (params: UerAnalysisStartSessionParams) => {
  const { http } = useHttp()
  const { auth } = useAuth()
  const email = auth.email
  const res = await http.post('/api/buyer-portal/api/rest/user-analysis/start-session', {
    objects: {
      email,
      anonymous: email ? '' : auth.mockToken || `anonymous-${randomUUID()}@air8.io`,
      device_info: JSON.stringify({
        user_agent: navigator.userAgent,
        screen_size: `${screen.width}x${screen.height}`,
        language: navigator.language
      }),
      ip_address: '',
      country_code: '',
      project_name: 'Air8 Client',
      ...params
    }
  })

  return _.get(res, 'insert_user_analysis_sessions.returning[0].id')
}

export type UserAnalysisTrackActionParams = UserAnalysisTrackActionType[]

export const userAnalysisTrackAction = async (
  actions: UserAnalysisTrackActionParams,
  options: { keepalive?: boolean } = {}
) => {
  if (options.keepalive) {
    const blob = new Blob(
      [
        JSON.stringify({
          objects: actions.map(action => ({
            ...action,
            action_details: JSON.stringify(action.action_details)
          }))
        })
      ],
      {
        type: 'application/json; charset=UTF-8'
      }
    )
    navigator.sendBeacon('/api/buyer-portal/api/rest/user-analysis/track-action', blob)
  }

  const { http } = useHttp()

  const res = await http.post('/api/buyer-portal/api/rest/user-analysis/track-action', {
    objects: actions.map(action => ({
      ...action,
      action_details: JSON.stringify(action.action_details)
    })),
    ...options
  })

  return _.get(res, 'insert_user_analysis_events.returning')
}
